import { type TileCoordinates } from "@/types/tile";
import { type FrameName } from "../entities/config";
import AbandonedHutSalvageableTileEntity from "../entities/salvagables/AbandonedHutSalvageableTileEntity";
import BanditCampLargeSalvageableTileEntity from "../entities/salvagables/BanditCampLargeSalvageableTileEntity";
import BanditCampMediumSalvageableTileEntity from "../entities/salvagables/BanditCampMediumSalvageableTileEntity";
import BanditCampSmallSalvageableTileEntity from "../entities/salvagables/BanditCampSmallSalvageableTileEntity";
import BarricadeEnemySalvageableTileEntity from "../entities/salvagables/BarricadeEnemySalvageableTileEntity";
import BearsDenSalvageableTileEntity from "../entities/salvagables/BearsDenSalvageableTileEntity";
import BurnedHouseSalvageableTileEntity from "../entities/salvagables/BurnedHouseSalvageableTileEntity";
import CaptainEnemySalvageableTileEntity from "../entities/salvagables/CaptainEnemySalvageableTileEntity";
import ChieftainEnemySalvageableTileEntity from "../entities/salvagables/ChieftainEnemySalvageableTileEntity";
import CollapsedMineSalvageableTileEntity from "../entities/salvagables/CollapsedMineSalvageableTileEntity";
import DamagedMillSalvageableTileEntity from "../entities/salvagables/DamagedMillSalvageableTileEntity";
import DeepSeaMediumPiratesSalvageableTileEntity from "../entities/salvagables/DeepSeaMediumPiratesSalvageableTileEntity";
import DeepSeaSmallPiratesSalvageableTileEntity from "../entities/salvagables/DeepSeaSmallPiratesSalvageableTileEntity";
import DepletedFieldSalvageableTileEntity from "../entities/salvagables/DepletedFieldSalvageableTileEntity";
import FlotsamJetsamSalvageableTileEntity from "../entities/salvagables/FlotsamJetsamSalvageableTileEntity";
import GrasslandCastleRuinsSalvageableTileEntity from "../entities/salvagables/GrasslandCastleRuinsSalvageableTileEntity";
import HillsCastleRuinsSalvageableTileEntity from "../entities/salvagables/HillsCastleRuinsSalvageableTileEntity";
import HornetsNestSalvageableTileEntity from "../entities/salvagables/HornetsNestSalvageableTileEntity";
import MercenaryCampSalvageableTileEntity from "../entities/salvagables/MercenaryCampSalvageableTileEntity";
import MercenaryShipSalvageableTileEntity from "../entities/salvagables/MercenaryShipSalvageableTileEntity";
import MerchantShipSalvageableTileEntity from "../entities/salvagables/MerchantShipSalvageableTileEntity";
import OldBattlefieldSalvageableTileEntity from "../entities/salvagables/OldBattlefieldSalvageableTileEntity";
import ShallowSeaMediumPiratesSalvageableTileEntity from "../entities/salvagables/ShallowSeaMediumPiratesSalvageableTileEntity";
import ShallowSeaRaidersFlagshipSalvageableTileEntity from "../entities/salvagables/ShallowSeaRaidersFlagshipSalvageableTileEntity";
import ShallowSeaRaidersGalleySalvageableTileEntity from "../entities/salvagables/ShallowSeaRaidersGalleySalvageableTileEntity";
import ShallowSeaRaidersSkiffSalvageableTileEntity from "../entities/salvagables/ShallowSeaRaidersSkiffSalvageableTileEntity";
import ShallowSeaRocksShipwreckSalvageableTileEntity from "../entities/salvagables/ShallowSeaRocksShipwreckSalvageableTileEntity";
import ShallowSeaShipwreckSalvageableTileEntity from "../entities/salvagables/ShallowSeaShipwreckSalvageableTileEntity";
import ShallowSeaSmallPiratesSalvageableTileEntity from "../entities/salvagables/ShallowSeaSmallPiratesSalvageableTileEntity";
import TravellingMerchantSalvageableTileEntity from "../entities/salvagables/TravellingMerchantSalvageableTileEntity";
import WarriorsEnemySalvageableTileEntity from "../entities/salvagables/WarriorsEnemySalvageableTileEntity";
import WolfsDenSalvageableTileEntity from "../entities/salvagables/WolfsDenSalvageableTileEntity";
import type TileEntity from "../entities/TileEntity";
import type TileRepository from "../TileRepository";

const map = new Map<FrameName, typeof TileEntity>();
map.set(
	AbandonedHutSalvageableTileEntity.frameName,
	AbandonedHutSalvageableTileEntity,
);
map.set(BearsDenSalvageableTileEntity.frameName, BearsDenSalvageableTileEntity);
map.set(
	BurnedHouseSalvageableTileEntity.frameName,
	BurnedHouseSalvageableTileEntity,
);
map.set(
	DepletedFieldSalvageableTileEntity.frameName,
	DepletedFieldSalvageableTileEntity,
);
map.set(
	GrasslandCastleRuinsSalvageableTileEntity.frameName,
	GrasslandCastleRuinsSalvageableTileEntity,
);
map.set(
	HillsCastleRuinsSalvageableTileEntity.frameName,
	HillsCastleRuinsSalvageableTileEntity,
);
map.set(
	MercenaryCampSalvageableTileEntity.frameName,
	MercenaryCampSalvageableTileEntity,
);
map.set(
	MercenaryShipSalvageableTileEntity.frameName,
	MercenaryShipSalvageableTileEntity,
);
map.set(
	MerchantShipSalvageableTileEntity.frameName,
	MerchantShipSalvageableTileEntity,
);
map.set(
	OldBattlefieldSalvageableTileEntity.frameName,
	OldBattlefieldSalvageableTileEntity,
);
map.set(
	ShallowSeaRocksShipwreckSalvageableTileEntity.frameName,
	ShallowSeaRocksShipwreckSalvageableTileEntity,
);
map.set(
	ShallowSeaShipwreckSalvageableTileEntity.frameName,
	ShallowSeaShipwreckSalvageableTileEntity,
);
map.set(
	TravellingMerchantSalvageableTileEntity.frameName,
	TravellingMerchantSalvageableTileEntity,
);
map.set(WolfsDenSalvageableTileEntity.frameName, WolfsDenSalvageableTileEntity);

map.set(
	BanditCampLargeSalvageableTileEntity.frameName,
	BanditCampLargeSalvageableTileEntity,
);
map.set(
	BanditCampMediumSalvageableTileEntity.frameName,
	BanditCampMediumSalvageableTileEntity,
);
map.set(
	BanditCampSmallSalvageableTileEntity.frameName,
	BanditCampSmallSalvageableTileEntity,
);
map.set(
	DeepSeaMediumPiratesSalvageableTileEntity.frameName,
	DeepSeaMediumPiratesSalvageableTileEntity,
);
map.set(
	DeepSeaSmallPiratesSalvageableTileEntity.frameName,
	DeepSeaSmallPiratesSalvageableTileEntity,
);
map.set(
	ShallowSeaMediumPiratesSalvageableTileEntity.frameName,
	ShallowSeaMediumPiratesSalvageableTileEntity,
);
map.set(
	ShallowSeaSmallPiratesSalvageableTileEntity.frameName,
	ShallowSeaSmallPiratesSalvageableTileEntity,
);
map.set(
	WarriorsEnemySalvageableTileEntity.frameName,
	WarriorsEnemySalvageableTileEntity,
);
map.set(
	BarricadeEnemySalvageableTileEntity.frameName,
	BarricadeEnemySalvageableTileEntity,
);
map.set(
	CaptainEnemySalvageableTileEntity.frameName,
	CaptainEnemySalvageableTileEntity,
);
map.set(
	ChieftainEnemySalvageableTileEntity.frameName,
	ChieftainEnemySalvageableTileEntity,
);
map.set(
	ShallowSeaRaidersSkiffSalvageableTileEntity.frameName,
	ShallowSeaRaidersSkiffSalvageableTileEntity,
);
map.set(
	ShallowSeaRaidersGalleySalvageableTileEntity.frameName,
	ShallowSeaRaidersGalleySalvageableTileEntity,
);
map.set(
	ShallowSeaRaidersFlagshipSalvageableTileEntity.frameName,
	ShallowSeaRaidersFlagshipSalvageableTileEntity,
);
map.set(
	FlotsamJetsamSalvageableTileEntity.frameName,
	FlotsamJetsamSalvageableTileEntity,
);
map.set(
	DamagedMillSalvageableTileEntity.frameName,
	DamagedMillSalvageableTileEntity,
);
map.set(
	CollapsedMineSalvageableTileEntity.frameName,
	CollapsedMineSalvageableTileEntity,
);
map.set(
	HornetsNestSalvageableTileEntity.frameName,
	HornetsNestSalvageableTileEntity,
);

// TODO: rename + rename file
export const getSalvageableTileEntity = (
	type: FrameName,
): typeof TileEntity | null => (map.has(type) ? map.get(type)! : null);

// TODO: rename + rename file
export const createSalvageableTileEntity = (
	type: FrameName,
	coordinates: TileCoordinates,
	tilerepo: TileRepository,
): TileEntity | null => {
	const entity = getSalvageableTileEntity(type);
	return entity ? new entity(coordinates, tilerepo) : null;
};
